import Base from './base'
import {
  CallDispositionResponse,
  CallSentimentResponse,
  CrmPhoneCustomField,
  Team,
} from '../types/logCall'

export default class LogCall extends Base {
  getCallSentiments(): Promise<CallSentimentResponse[]> {
    return this.api.get('sentiments')
  }

  getCallDisposition(): Promise<CallDispositionResponse[]> {
    return this.api.get('dispositions')
  }

  getCrmCustomFields(): Promise<CrmPhoneCustomField[]> {
    return this.api.get('teams/crm_fields?editable_source=phone')
  }

  getCurrentTeam(): Promise<Team> {
    return this.api.get('teams')
  }
}
